import axios from 'axios';
import { GET_ITINERARIES, GET_FLIGHT_NETWORK, GET_ITINERARIES_NETWORK, GET_ROUTE_PRICE } from './define';

export const getRoutePrice = ({ lang }) => {
    return axios.get(GET_ROUTE_PRICE, {
        params: { lang },
        withCredentials: false
    }); 
}

export const getItineraries = ({ token, from, to, lang }) => {
    const platform = 3;
    return axios.get(GET_ITINERARIES, {
        params: {
            token,
            from,
            to,
            lang,
            platform
        },
        withCredentials: false
    });
}

export const getItinerariesNetwork = ({ token, codeshareChecked }) => {
    return axios.get(GET_ITINERARIES_NETWORK, {
        params: {
            token,
            codeshareChecked
        },
        withCredentials: false
    });
}

export const getAllRoutes = ({ token, from }) => {
    return axios.get(GET_FLIGHT_NETWORK, {
        params: {
            token,
            from
        },
        withCredentials: false
    });
}